<template>
  <div class="container">
    <div v-for="item in list" :key="item.id">
      <router-link :to="`/newPage?id=${item.id}`" class="item">
        <img :src="item.picUrl" alt="" class="igm-logo">
        <div class="item-box">
          <div class="box-left">
            <div class="title">{{item.title}}</div>
            <div class="text">杭州公安党史学习教育纪实</div>
          </div>
          <div class="box-right">点击进入</div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { wxNewsTitleList } from '@/api/home'
export default {
  data() {
    return {
      list: []
    }
  },
  created() {
    wxNewsTitleList({}).then(res => {
      this.list = res.body
    })
  }
}
</script>

<style lang="scss" scoped>
@function vw($n) {
  @return $n / 7.5 * 1vw;
}

.container {
  padding: 0 vw(24) vw(24);
}
.item {
  width: vw(702);
  height: vw(366);
  background: linear-gradient(0deg, #F6F6F6, #FFFFFF);
  border-radius: vw(20);
  margin-top: vw(35);
  text-decoration: none;
  display: block;
}
.igm-logo {
  width: 100%;
  height: vw(230);
  border-radius: vw(20) vw(20) 0 0;
  display: block;
}
.item-box {
  display: flex;
  margin-top: vw(22);
}
.box-left {
  text-align: left;
  margin-left: vw(48);
  width: vw(478);
}
.title {
  font-size: vw(33);
  color: #000;
  font-weight: bold;
}
.text {
  font-size: vw(28);
  color: #A7A7A7;
  margin-top: vw(10);
}
.box-right {
  font-size: vw(30);
  color: #898989;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-right::after {
  content: " ";
  display: inline-block;
  height: 1.4vw;
  width: 1.4vw;
  border-width: 0.6vw 0.6vw 0 0;
  border-color: #A3A3A3;
  border-style: solid;
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
}
</style>
